import { render } from "./Navbarv2.vue?vue&type=template&id=684943fd&scoped=true"
import script from "./Navbarv2.vue?vue&type=script&lang=js"
export * from "./Navbarv2.vue?vue&type=script&lang=js"

import "./Navbarv2.vue?vue&type=style&index=0&id=684943fd&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684943fd"]])

export default __exports__